import { applyMiddleware, compose, createStore } from 'redux'

import rootReducer from './reducers/index'
import thunkMiddleware from 'redux-thunk'

const middleware = []

middleware.push(thunkMiddleware)

let enhancer = applyMiddleware(...middleware)

if (window.__REDUX_DEVTOOLS_EXTENSION__ != null) {
  enhancer = compose(
    enhancer,
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'function' ? window.__REDUX_DEVTOOLS_EXTENSION__() : undefined
  )
}

const store = createStore(rootReducer, {}, enhancer)

export default store
